import DAHomeService from '../home/DAHomeService';

export default DAHomeService;
